import type { RouteRecordRaw } from 'vue-router';

import { BasicLayout } from '#/layouts';

const routes: RouteRecordRaw[] = [
  {
    component: BasicLayout,
    meta: {
      icon: 'mdi:marketplace-outline',
      order: 7,
      title: '服务市场',
      keepAlive: true,
    },
    path: '/market',
    // redirect: () => {
    //   const { hasAccessByRoles } = useAccess();
    //   return hasAccessByRoles(['normal'])
    //     ? '/market/internationalLogistics'
    //     : '/market/authShop';
    // },
    redirect: '/market/shopAuth',
    name: 'MarketBase',
    children: [
      /* {
        name: 'InternationalLogistics',
        path: 'internationalLogistics',
        component: () =>
          import('#/views/market/internationalLogistics/index.vue'),
        meta: {
          icon: 'majesticons:airplane-line',
          title: $t('page.dashboard.internationalLogistics'),
          keepAlive: true,
          authority: ['normal'],
          order: 1,
        },
      },*/
      {
        name: 'Auth',
        path: 'shopAuth',
        component: () => import('#/views/market/authShop/index.vue'),
        meta: {
          icon: 'mdi:shop',
          title: '授权店铺',
          keepAlive: true,
          order: 2,
        },
      },
      {
        name: 'AutoBuyTool',
        path: 'autoBuyTool',
        component: () => import('#/views/market/buyTool/buyerList.vue'),
        meta: {
          icon: 'mdi:toolbox',
          title: '自动拍单工具',
          keepAlive: true,
          order: 3,
          authority: ['showMerchantPlugin'],
        },
      },
      {
        name: 'TiktokOpportunityCenterLegacy',
        path: 'opportunityCenter',
        redirect: '/tiktok-tools/opportunity',
        meta: {
          hideInMenu: true,
          title: '商品机会',
        },
      },
      {
        name: 'TiktokOperationsAnalyticsLegacy',
        path: 'tiktokAnalytics',
        redirect: '/tiktok-tools/analytics/shop',
        meta: {
          hideInMenu: true,
          title: '运营分析',
        },
      },
      {
        name: 'MarketTicketCenter',
        path: 'ticket',
        component: () => import('#/views/workspace/ticket/index.vue'),
        meta: {
          icon: 'lucide:messages-square',
          title: '工单中心',
          keepAlive: true,
          order: 9,
        },
      },
      {
        name: 'MarketTicketDetail',
        path: 'ticket/:id',
        component: () => import('#/views/workspace/ticket/detail.vue'),
        meta: {
          hideInMenu: true,
          title: '工单详情',
        },
      },
      // {
      //   name: 'Auth',
      //   path: 'authShop',
      //   component: () => import('#/views/market/authShop/index.vue'),
      //   meta: {
      //     icon: 'mdi:shop',
      //     title: $t('page.dashboard.authShop'),
      //     keepAlive: true,
      //     authority: ['test'],
      //   },
      // },
    ],
  },
];

export default routes;
